import { AfterContentInit, Component, ElementRef, Inject, forwardRef } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { WorkOrder } from "../../model";
import { AppService } from "../../service/app.service";
import { AuthenticationService } from "../../service/authentication.service";
import { CustomTableColumn, CustomTableService } from "../../shared/custom-table";
import { ListWidgetV2Component } from "../../shared/list-widget-v2/list-widget-v2.components";
import { MinutesToHoursFormatterPipe } from "../../shared/pipe/minutes-to-hours-formatter.pipe";
import { ServitlyBadgePipe } from "../../shared/pipe/servitly-badge.pipe";
import { WorkOrderStatusPipe } from "../../shared/pipe/work-order-status.pipe";
import { ErrorUtility } from "../../utility/error-utility";
import { WidgetPrintResizeCoordinatorService } from "../shared/widget-print-resize-coordinator.service";
import { ActionListWidgetV2Service } from "./action-list-widget-v2.service";


@Component({
    selector: 'work-order-list-dialog',
    template: require('./work-order-list-dialog.component.html')
})
export class WorkOrderListDialogComponent extends ListWidgetV2Component<WorkOrder> implements AfterContentInit {

    workOrders: WorkOrder[];
    displayedColumns: CustomTableColumn[] = [
        CustomTableService.newSimpleColumn('code', 'codeProperty', 'code'),
        CustomTableService.newDatetimeColumn('endTimestamp', 'completionProperty', 'endTimestamp', 'YYYY-MM-DD'),
        CustomTableService.newPipedColumn('totalWorkTime', 'workTimeProperty', 'totalWorkTime', MinutesToHoursFormatterPipe).withColumnClass('align-content-right'),
        CustomTableService.newPipedColumn('status', '', 'status', WorkOrderStatusPipe).withStyle({ '_any': { 'width': '1%' } })
    ];
    private actionListWidgetV2Service: ActionListWidgetV2Service;
    private thingId: string;

    constructor(
        @Inject(forwardRef(() => MatDialogRef)) public dialogRef: MatDialogRef<WorkOrderListDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data,
        @Inject(forwardRef(() => AuthenticationService)) protected authenticationService: AuthenticationService,
        @Inject(forwardRef(() => AppService)) appService: AppService,
        @Inject(forwardRef(() => MatDialog)) dialog: MatDialog,
        @Inject(forwardRef(() => ElementRef)) elementRef: ElementRef,
        @Inject(forwardRef(() => WidgetPrintResizeCoordinatorService)) coordinator: WidgetPrintResizeCoordinatorService,
    ) {
        super(appService, authenticationService, null, null, dialog, null, null, elementRef, coordinator);
        this.actionListWidgetV2Service = data.actionListWidgetV2Service;
        this.thingId = data.thingId;
        this.pageSize = 10;
    }

    ngAfterContentInit(): void {
        this.sort = ['code', 'asc'];
        this.getWorkOrderList();
        if (this.authenticationService.isNewStyleManagerEnabled()) {
            this.displayedColumns[3] = CustomTableService.newPipedColumn('status', '', 'status', ServitlyBadgePipe).withArgument({ colorTokenPrefix: 'work-order-status' }).withStyle({ '_any': { 'width': '1%' } })
        }
    }

    getWorkOrderList(): void {
        this.loaded = false;
        this.actionListWidgetV2Service.getWorkOrderPagedList(this.pageIndex, this.pageSize, this.sort, this.thingId, false, this.advancedSearchBody).then(pagedList => {
            this.workOrders = pagedList.content;
            this.error = null;
            this.updateElementList(pagedList);
        }).catch(err => this.error = ErrorUtility.getMessage(err));
    }

    refreshList(data?: { pageIndex: number, pageSize: number, advancedSearchBody: any, sort: string[] }): void {
        this.loaded = false;
        if (data) {
            this.pageIndex = data.pageIndex;
            this.pageSize = data.pageSize;
            this.advancedSearchBody = data.advancedSearchBody;
            this.sort = data.sort;
        }
        this.getWorkOrderList();
    }

    protected goToDetail(element: WorkOrder): void {
        this.dialogRef.close(element);
    }

    protected subscribeToExportServices(): void {
        // do nothing
    }

}